import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CornerRoundImg } from "../../common-styling";

const NoteContainer = styled.div`
  min-height: 80px;
  max-height: 150px;
  overflow-y: scroll;
`;

const PreviewDialog = (props) => {
  const { t } = useTranslation();
  return (
    <Modal {...props} size="md" centered>
      <CornerRoundImg src={props.data?.url} />
      <NoteContainer className="bg-white mb-2 p-3 border-top rounded-bottom">
        <h6 className="fw-bold">{t("suggestionGallery.noteLabel")}:</h6>
        {props.data?.note || "---"}
      </NoteContainer>
    </Modal>
  );
};

export default PreviewDialog;
